module.exports = __webpack_public_path__ + "static/media/logo-cps.ebd9cfbf.jpg";